<app-header [title]="Title"></app-header>
<!-- Midd content -->
<div class="container-fluid p-0">
  <form class="row" role="form">
    <div class="col-md-3 p-0 blue-seprator serpartion-htg">
      <form [formGroup]="InstructionForm" (ngSubmit)="FormSubmit()" novalidate>
        <div class="col-md-12 col-sm-12 mt-10">
          <div class="heading-panel pt-0 pl-0">
            <span class="text-sm text-ellipsis heading-txt t-uppercase blue-text">Instructions</span>
          </div>
        </div>
        <div class="col-md-12 p-0 instruction-gp1">
          <div class="col-md-12 p-0 d-flex">
          <div class="col-md-6 p-0">
          <div class="form-group  mh-15">
            <label class=" label-std control-label p-0 b-600 pl-0">Client
              <span class="required-asterisk">*</span>
            </label>
            <app-common-dropdown-search  [data]="ClientList" [addFieldSetting]="addFieldSetting" (callEvent)="ClientListOnChange($event)"></app-common-dropdown-search>
            <!-- <select [ngClass]="{'input-error': InstructionForm.get('Client').value < 1 && Validated}"
             formControlName="Client" [disabled]="DisableClientList" name="Client"
              [(ngModel)]="InstructionModel.Client_Id" (change)="ClientListOnChange($event)" class="form-control">
              <option [selected]="ClientList.length >1" value="0" disabled>Select</option>
              <option *ngFor="let c of ClientList; let i = index" [value]="c.Client_Id" [selected]="c.selected">
                {{c.Client_Name}}</option>
            </select> -->

            <!-- <div class="error" *ngIf="InstructionForm.get('Client').value < 1 && Validated">
              Client Selection required
              {{InstructionForm.setErrors({ 'invalid': true })}}
            </div> -->
          </div>
          </div>
          <div class="col-md-6 p-0">
          <div class="form-group mh-15">

            <label for="PayerList" class="label-std control-label p-0 b-600">Payer
              <span class="required-asterisk">*</span>
            </label>
            <select [ngClass]="{'input-error': InstructionForm.get('Payer').value < 1 && Validated}"
             [disabled]="DisableAll" formControlName="Payer" class="form-control" name="Payer"
              [(ngModel)]="InstructionModel.Payer_Name">

              <option value="" [selected]=" (InstructionModel.Payer_Name != null) ||InstructionModel.Payer_Name == ''"
                disabled>
                Select</option>
              <option *ngFor="let item of PayerList; let i = index" [value]="item.Value" [selected]="item.selected ">
                {{item.Value}} </option>
            </select>

            <!-- <div class="error" *ngIf="InstructionForm.get('Payer').value < 1 && Validated">
              Payer Selection required
              {{InstructionForm.setErrors({ 'invalid': true })}}
            </div> -->
          </div>
          </div>
          </div>
          <div class="col-md-12 p-0 d-flex">
          <div class="col-md-6 p-0">
          <div class="form-group mh-15">
            <label for="PracticeList" class="label-std control-label p-0 b-600">Practice
              <span class="required-asterisk">*</span>
            </label>
            <select [ngClass]="{'input-error': InstructionForm.get('Practice').value < 1 && Validated}"
             [disabled]="DisableAll" formControlName="Practice" class="form-control" name="Practice"
              [(ngModel)]="InstructionModel.Practice_Name">
              <option value="" [selected]="!InstructionModel.Practice_Name" disabled>Select</option>
              <option *ngFor="let item of PracticeList; let i = index" [value]="item.Value" [selected]="item.selected">
                {{item.Value}} </option>
            </select>


            <!-- <div class="error" *ngIf="InstructionForm.get('Practice').value < 1 && Validated">
              Practice Selection required
              {{InstructionForm.setErrors({ 'invalid': true })}}
            </div> -->
          </div>
        </div>
          <div class="col-md-6 p-0">
          <div class="form-group mh-15">
            <label for="ProviderList" class="label-std control-label p-0 b-600">Provider
              <span class="required-asterisk">*</span>
            </label>
            <select [ngClass]="{'input-error': InstructionForm.get('Provider').value < 1 && Validated}"
             [disabled]="DisableAll" formControlName="Provider" class="form-control" name="Provider"
              [(ngModel)]="InstructionModel.Provider_Name">
              <option value="" [selected]="!InstructionModel.Provider_Name" disabled>Select</option>
              <option *ngFor="let item of ProviderList; let i = index" [value]="item.Value" [selected]="item.selected">
                {{item.Value}}</option>
            </select>
            <!-- <div class="error" *ngIf="InstructionForm.get('Provider').value < 1 && Validated">
              Provider Selection required
              {{InstructionForm.setErrors({ 'invalid': true })}}
            </div> -->
          </div>
          </div>
          </div>

          <div class="col-md-12 p-0 d-flex">
            <div class="col-md-6 p-0">
             <div class="form-group  mh-15">
                <label class=" label-std control-label p-0 b-600 pl-0">Source
                  <span class="required-asterisk">*</span>
                </label>
                <select [ngClass]="{'input-error': InstructionForm.get('Source').value < 1 && Validated}" [disabled]="DisableAll" formControlName="Source" class="form-control" name="Source"
                  [(ngModel)]="InstructionModel.Source">

                  <option value="" [selected]=" (InstructionModel.Source != null) ||InstructionModel.Source == ''"
                    disabled>
                    Select</option>
                  <option *ngFor="let item of SourceList; let i = index" [value]="item.Value" [selected]="item.selected ">
                    {{item.Value}} </option>
                </select>

                <!-- <div class="error" *ngIf="InstructionForm.get('Source').value < 1 && Validated">
                  Source Selection required
                  {{InstructionForm.setErrors({ 'invalid': true })}}
                </div> -->
              </div>
            </div>

            <div class="col-md-6 p-0">
              <div class="form-group  mh-15">
                <label class=" label-std control-label p-0 b-600 pl-0">Communication Channel
                  <span class="required-asterisk">*</span>
                </label>
                <select [ngClass]="{'input-error': InstructionForm.get('CommunicationChannel').value < 1 && Validated}" [disabled]="DisableAll" formControlName="CommunicationChannel" class="form-control" name="CommunicationChannel"
                  [(ngModel)]="InstructionModel.Communication_Channel">

                  <option value="" [selected]=" (InstructionModel.Communication_Channel != null) ||InstructionModel.Communication_Channel == ''"
                    disabled>
                    Select</option>
                  <option *ngFor="let item of CommunicationChannelList; let i = index" [value]="item.Value" [selected]="item.selected ">
                    {{item.Value}} </option>
                </select>

                <!-- <div class="error" *ngIf="InstructionForm.get('CommunicationChannel').value < 1 && Validated">
                  Communication Channel Selection required
                  {{InstructionForm.setErrors({ 'invalid': true })}}
                </div> -->
              </div>
            </div>
          </div>

          <div class="col-md-12 p-0 d-flex">
            <div class="col-md-6 p-0">
              <div class="form-group mh-15">

                <label for="PayerList" class="label-std control-label p-0 b-600">Add Attachement</label>
                <div style="margin-bottom: 0.5rem;" class="col-md-12 file-upload-wrapper p-0 mb-15"
                [attr.data-text]="FileFormname">
                <input (change)="GetFileFormData($event)" #fileAttachement [disabled]="DisableFileInput" name="file-upload-field"
                  type="file" accept=".jpeg,.jpg,.png,.pdf,.xlsx,.doc,.docx,.txt,.pst,.eml,.msg" class="file-upload-field" (onclick)="fileAttachement.value = null">

                </div>
                <!-- </span> -->
                <!-- <div class="error" *ngIf="fileSizeExceeds">
                  Please select the file less than 5MB
                </div> -->
                <div class="error" *ngIf="DisplayFileError">
                  Please select the file
                </div>

              </div>
            </div>

            <div class="col-md-6 p-0">
              <div class="form-group mh-15">
                <label for="Received_From" class="label-std  control-label p-0 b-600">Received From
                  <span class="required-asterisk">*</span>
                </label>
                <input [ngClass]="{'input-error': InstructionForm.get('Received_From').hasError('required') && Validated}" [disabled]="DisableAll" formControlName="Received_From" rows="5" maxlength="50" name="Received_From"
                  class="form-control textarea-resize" [(ngModel)]="InstructionModel.Received_From"
                  placeholder="Enter Received From">
                <!-- <div class="error" *ngIf="InstructionForm.get('Instruction').hasError('required') && Validated">
                  Text required
                </div> -->
              </div>
              </div>

          </div>


          <div class="col-md-12 p-0 d-flex">
            <div class="col-md-6 p-0">
              <!-- <div class="col-md-6 p-0"> -->
                <div class="form-group mh-15 mt-20">
                  <label class=" label-std control-label p-0 b-600 pl-0">Update Category
                    <span class="required-asterisk">*</span>
                  </label>
                  <select [ngClass]="{'input-error': InstructionForm.get('UpdateCategory').value < 1 && Validated}" [disabled]="DisableAll" formControlName="UpdateCategory" class="form-control mt-2" name="UpdateCategory"
                    [(ngModel)]="InstructionModel.Update_Category">

                    <option value="" [selected]=" (InstructionModel.Update_Category != null) ||InstructionModel.Update_Category == ''"
                      disabled>
                      Select</option>
                    <option *ngFor="let item of UpdateCategoryList; let i = index" [value]="item.Value" [selected]="item.selected ">
                      {{item.Value}} </option>
                  </select>

                  <!-- <div class="error" *ngIf="InstructionForm.get('UpdateCategory').value < 1 && Validated">
                    Update Category Selection required
                    {{InstructionForm.setErrors({ 'invalid': true })}}
                  </div> -->
                <!-- </div> -->
              </div>


          <div class="form-group mh-15 mt-20">
            <label for="Instruction" class="label-std  control-label p-0 b-600">Instruction
              <span class="required-asterisk">*</span>
            </label>
            <a class="instructionAnchor" (click)="openInstructionPopup()"> Click here to Add Updates</a>
            <div class="error" *ngIf="(InstructionForm.get('Instructions_Scenario').hasError('required')&& Validated) || (InstructionForm.get('Instructions_Action').hasError('required') && Validated)">
              Instructions required
            </div>
            <!-- <textarea [disabled]="DisableAll" formControlName="Instruction" rows="5" maxlength="500" name="Instruction"
              class="form-control textarea-resize" [(ngModel)]="InstructionModel.Instructions"
              placeholder="Enter Instructions"></textarea>
            <div class="error" *ngIf="InstructionForm.get('Instruction').hasError('required') && Validated">
              Instructions required
            </div> -->
          </div>
        </div>
          <div class="col-md-6 p-0 mt-20">
          <div class="form-group mh-15">
            <div class="col-md-12 p-0">
              <label class=" label-std control-label p-0 b-600 pl-0">Update Specification</label>
              <span class="col-md-6 p-0 text-left">
                <label class="custom-control client-conf">
                  <!-- <input [checked]="InstructionModel.Instructions.length > 1" name="IsCPT" type="checkbox" id="ac-cpt" (click)="checkEnableCheckbox($event)"> -->
                  <!-- <input [disabled]="DisableAll" [(ngModel)]="InstructionModel.Is_Active" name="IsCPT"
                    formControlName="IsActive" type="checkbox" id="ac-cpt" (click)="checkEnableCheckbox($event)"> -->
                    <!-- [ngClass]="{'input-error': chkCPTEnable && InstructionModel.Instructions.length == 0,
                    'input-error-enabled': chkCPTEnable }" -->
                  <label for="ac-cpt" class="ac-inputLabel">
                    <input [disabled]="DisableAll" formControlName="IsCPTCode" rows="1" maxlength="50" name="IsCPTCode"
                      class="form-control textarea-resize inputLabel mt-2" [(ngModel)]="InstructionModel.CPT_Code"
                      placeholder="Enter CPT Code">
                  </label>
                  </label>
              </span>
              <span class="col-md-6 p-0 text-left">
                <label class="custom-control client-conf">
                  <!-- <input name="IsRevenue" type="checkbox" id="ac-revenue" (click)="checkEnableCheckbox($event)"> -->
                  <!-- [ngClass]="{'input-error': chkRevenueEnable && InstructionModel.Revenue_Code.length == 0}" -->
                  <label for="ac-revenue">
                    <input [disabled]="DisableAll" formControlName="IsRevenueCode" rows="1" maxlength="50" name="IsRevenueCode"
                    class="form-control textarea-resize inputLabel" [(ngModel)]="InstructionModel.Revenue_Code"
                    placeholder="Enter Revenue Code">
                  </label>
                </label>
              </span>
              <span class="col-md-6 p-0 text-left">
                <label class="custom-control client-conf">
                  <!-- <input name="IsDiagnosis" type="checkbox" id="ac-diagnosis" (click)="checkEnableCheckbox($event)"> -->
                  <!-- [ngClass]="{'input-error': chkDiagnosisEnable && InstructionModel.Diagnosis_Code.length == 0}"  -->
                  <label for="ac-diagnosis">
                    <input [disabled]="DisableAll" formControlName="IsDiagnosisCode" rows="1" maxlength="50" name="IsDiagnosisCode"
                    class="form-control textarea-resize inputLabel" [(ngModel)]="InstructionModel.Diagnosis_Code"
                    placeholder="Enter Diagnosis Code">
                    </label>
                </label>
              </span>
              <span class="col-md-6 p-0 text-left">
                <label class="custom-control client-conf">
                  <!-- <input name="IsModifier" type="checkbox" id="ac-modifier" (click)="checkEnableCheckbox($event)"> -->
                  <!-- [ngClass]="{'input-error': chkModifierEnable && InstructionModel.Instructions.length == 0}" -->
                  <label for="ac-modifier">
                    <input [disabled]="DisableAll" formControlName="IsModifierCode" rows="1" maxlength="50" name="IsModifierCode"
                    class="form-control textarea-resize inputLabel" [(ngModel)]="InstructionModel.Modifier"
                    placeholder="Enter Modifier Code">
                    </label>
                </label>
              </span>
              <span class="col-md-6 p-0 text-left">
                <label class="custom-control client-conf">
                  <!-- <input name="IsPlaceOfService" type="checkbox" id="ac-placeofservice" (click)="checkEnableCheckbox($event)"> -->
                  <!-- [ngClass]="{'input-error': chkPlaceOfServiceEnable && InstructionModel.Place_of_Service.length == 0}" -->
                  <label for="ac-placeofservice">
                    <input [disabled]="DisableAll" formControlName="IsPlaceOfServiceCode" rows="1" maxlength="50" name="IsPlaceOfServiceCode"
                    class="form-control textarea-resize inputLabel" [(ngModel)]="InstructionModel.Place_of_Service"
                    placeholder="Enter Place of Service Code">
                    </label>
                </label>
              </span>

              <span class="col-md-6 p-0 text-left">
                <label class="custom-control client-conf">
                  <input [disabled]="DisableAll" [(ngModel)]="InstructionModel.Is_Active" name="IsActive"
                    formControlName="IsActive" type="checkbox" id="ac-active">
                  <label for="ac-active">Is Active</label>
                </label>
              </span>
            </div>
            <div class="error" *ngIf="ShowRoleError">
              {{RoleMessage}}
            </div>
          </div>
          </div>
          </div>

          <div class="col-md-12 text-left" id="btnContainer">
            <button type="submit" [disabled]="DisableAll || !canEdit" class="btn blue square-btn blue-hover btn-txt btn-default"
              id="toast-btn">Save</button>
            <button type="button" [disabled]="DisableAll" (click)="ClearData()"
              class="btn blue square-btn blue-hover btn-txt btn-default">Clear</button>
            <div class="error" *ngIf="!canEdit && selectedRecord"> This role cannot edit this instruction</div>
            <!--
                    <button type="button" style="float: left" [disabled]="DisableAll || !canEdit" class="btn blue square-btn blue-hover btn-txt"
                      id="toast-btn">Bulk Upload</button>
                    <button type="button" style="float: left" [disabled]="DisableAll" class="btn blue square-btn blue-hover btn-txt ">Template
                      Download</button>
                    <div class="error" *ngIf="!canEdit && selectedRecord"> This role cannot edit this instruction</div> -->
          </div>
          <div class="form-group mh-15 mt-2">
            <label class="label-std control-label p-0 b-600 pl-0" for="">Upload Updates in Bulk</label>
            <div style="margin-bottom: 0.5rem;" class="col-md-12 file-upload-wrapper p-0 mb-15"
              [attr.data-text]="Filename">
              <input (change)="GetFileData($event)" #file [disabled]="DisableFileInput" name="file-upload-field"
                type="file" accept=".xlsx" class="file-upload-field" (onclick)="file.value = null">

            </div>
            <!-- </span> -->
            <div class="error" *ngIf="DisplayFileError">
              Please select the file
            </div>

            <button [disabled]="!truefile || DisableUpload" type="button" (click)="FileUpload()"
              class="btn w-auto pr-upl label btn-default label-info-padding label-info square-btn cursor mt-1 mr-5" id="toast-btn">
              <i class="fa fa-upload mr-5" aria-hidden="true"></i>Upload</button>

            <button [disabled]="disableDownload" type="button" (click)="downloadTemplate()"
              class="btn w-auto pr-upl label btn-default label-info-padding label-info square-btn cursor mt-1 mr-5" id="toast-btn">
              <i class="fa fa-download mr-5" aria-hidden="true"></i>Download Template</button>
          </div>

        </div>
      </form>
    </div>

    <div class="col-md-9">
      <div class="row">
        <div class="col-md-12 col-sm-12 p-0 mt-10">
          <div class="heading-panel pt-0 pl-0">
            <span class="text-sm text-ellipsis heading-txt t-uppercase blue-text"> Client Instructions</span>
            <div class="exportBtn">
              <button type="button" (click)="exportToExcel()" [disabled]="!RowData || RowData.length==0"
                class="btn blue square-btn blue-hover btn-txt btn-default">
                <i class="fa fa-file-excel-o mr-5" aria-hidden="true"></i> Export To Excel</button>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-sm-12 p-0 insrt-tbl">
          <div class="sticky-table sticky-ltr-cells border-0 table-hight">
            <ag-grid-angular class="ag-theme-balham gd-w" (firstDataRendered)="AutoSizeGrid($event)"
              (gridReady)="OnGridReady($event)" [rowSelection]="RowSelection" [rowData]="RowData"
              (columnResized)="onColumnResized($event)" [columnDefs]="ColumnDefs" [pagination]="true"
              [paginationAutoPageSize]="true" [enableColResize]="true" [enableSorting]="true" [enableFilter]="true"
              (rowData)="OnGridReady($event)" [suppressColumnVirtualisation]="true" (rowClicked)="OnRowClicked($event)"
              (cellClicked)='onCellClicked($event)'>
            </ag-grid-angular>
          </div>
        </div>
      </div>

    </div>

  </form>
</div>


<app-count-model *ngIf="viewCountData" [readCountData]="readCountData" [sendToCountModel]="sendToCountModel" (Toggle)="ToggleModal()"></app-count-model>

<app-instruction-poup-box *ngIf="viewInstructionBox" [disabledInstruction]="disabledInstruction" [getClientID]="sendClientID" (Toggle)="ToggleInstructionModal($event)"></app-instruction-poup-box>

<!-- end midd content -->
